import { createFileRoute } from "@tanstack/react-router";

import HeatmapPage from "@/admin/reports/heatmap/page";

export const Route = createFileRoute("/app/$storeId/reports/heatmap")({
    component: RouteComponent,
});

function RouteComponent() {
    return <HeatmapPage />;
}
